import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConvertToINRPipe } from './custom.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RangebarComponent } from './rangebar/rangebar.component';
// import { CustomOtpInputModule } from './custom-otp-input/custom-otp-input.module';
import {MatSliderModule} from '@angular/material/slider';
import { OptoutComponent } from './optout/optout.component';
import { SetuppinComponent } from './setuppin/setuppin.component';
// import { MatDatepickerModule } from '@angular/material/datepicker';
// import { MatTooltipModule } from '@angular/material/tooltip';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgOtpInputModule } from 'ng-otp-input';
import { MatInputModule } from '@angular/material/input';
@NgModule({
  declarations: [ConvertToINRPipe, RangebarComponent, OptoutComponent, SetuppinComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // CustomOtpInputModule,
    MatSliderModule,
    MatInputModule,
    // MatDatepickerModule,
    // MatTooltipModule,
    NgbModule,
    NgOtpInputModule
  ],
  exports: [ConvertToINRPipe , RangebarComponent, OptoutComponent , SetuppinComponent] 
  // exports: [ConvertToINRPipe , RangebarComponent,CustomOtpInputModule, OptoutComponent , SetuppinComponent] 
})
export class SharedModule { }
